import React from "react";
import { Hero, Section, CTA } from "../components/Page/Page.js";
import { faqs } from "../data/content.js";

export default function FAQScreen() {
  return (
    <>
      <Hero title="Frequently Asked Questions" />
      <Section>
        <div className="pg-faq">
          {faqs.map(([q, a]) => (
            <details key={q}><summary>{q}</summary><p>{a}</p></details>
          ))}
        </div>
      </Section>
      <CTA text="Still have questions?" />
    </>
  );
}
